import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FeatureToggleDirective} from '@emm/core/directives/feature-toggle.driective';
import {DragAndDropDirective} from './directives/drag-and-drop.directive';
import {AppInfoService} from '@emm/core/services/app-info.service';
import {AttributeService} from '@emm/core/services/attribute.service';
import {ChangeSetService} from '@emm/core/services/change-set.service';
import {ConsumerManagerService} from '@emm/core/services/consumer-manager.service';
import {ItemIdMappingsService} from '@emm/core/services/item-id-mappings.service';
import {ItemGroupingService} from '@emm/core/services/item-grouping.service';
import {LockItemService} from '@emm/core/services/lock-item.service';
import {LocationSetService} from '@emm/core/services/location-set.service';
import {LocalesService} from '@emm/core/services/locales.service';
import {ItemTypeService} from '@emm/core/services/item-type.service';
import {ItemTypeClassService} from '@emm/core/services/item-type-class.service';
import {TagService} from '@emm/core/services/tag.service';
import {VenueService} from '@emm/core/services/venue.service';
import {ReportService} from '@emm/core/services/report.service';
import {PinOverridesService} from '@emm/core/services/pin-overrides.service';
import {MenuService} from '@emm/core/services/menu.service';
import {NutritionService} from '@emm/core/services/nutrition.service';
import {LocationStatusService} from '@emm/core/services/location-status.service';
import {MasterMenuSystemService} from '@emm/core/services/master-menu-system.service';
import {ConsumerService} from '@emm/core/services/consumer.service';
import {ItemService} from '@emm/core/services/item.service';
import {LocationSetTypeService} from '@emm/core/services/location-set-type.service';
import {UserService} from '@emm/core/services/user.service';
import {MenuRestrictionsService} from '@emm/core/services/menu-restrictions.service';


@NgModule({
    declarations: [
        FeatureToggleDirective,
        DragAndDropDirective,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FeatureToggleDirective,
        DragAndDropDirective
    ],
    providers: [
        AppInfoService, AttributeService, ChangeSetService, ConsumerManagerService,
        ConsumerService, LockItemService, ItemGroupingService, ItemIdMappingsService,
        ItemService, ItemTypeClassService, ItemTypeService, LocalesService, LocationSetService,
        LocationSetTypeService, LocationStatusService, MenuService, ReportService, TagService,
        UserService, MasterMenuSystemService, NutritionService, PinOverridesService, VenueService, AppInfoService,
        MenuRestrictionsService
    ]
})
export class CoreModule {
}
